<div class="ai-search-panel">
    <div class="panel-header">
        <h3>AI Search</h3>
        <p>Coming Soon....</p>
    </div>
</div>

<!-- <div class="ai-search-panel">
    <div class="panel-header">
        <h3>AI Search</h3>
        <p>Describe what you want to find</p>
    </div>


    <div class="query-section">
        <label for="userQuery">What are you looking for?</label>

        <div class="input-container">
            <textarea
                #userQueryInput
                id="userQuery"
                [(ngModel)]="userQuery"
                (keydown)="onUserQueryKeyDown($event)"
                (input)="onUserQueryChange()"
                (focus)="onUserQueryFocus()"
                (blur)="onUserQueryBlur()"
                placeholder="e.g., Show me all records where @Client ID equals '123' and @Company Name contains 'apple'"
                class="query-input"
                rows="3"
            >
            </textarea>


            <div class="autocomplete-dropdown" *ngIf="showAutocomplete">
                <div class="autocomplete-header">Available Column Fields (use @ prefix)</div>
                <div class="autocomplete-options">
                    <div
                        class="autocomplete-option"
                        [class.selected]="i === selectedAutocompleteIndex"
                        *ngFor="let option of autocompleteFilteredOptions; let i = index"
                        (click)="selectAutocompleteOption(option)"
                    >
                        <span>@{{ option }}</span>
                    </div>
                </div>
            </div>
        </div>

        <button class="generate-btn" (click)="generateQueryWithAI()" [disabled]="!userQuery.trim() || isLoading">
            <span *ngIf="!isLoading">Generate Query</span>
            <span *ngIf="isLoading">Generating...</span>
        </button>
    </div>


    <div class="error-section" *ngIf="error">
        <div class="error-card">
            <div class="error-header">
                <strong>Error:</strong>
                <span>{{ error }}</span>
                <button class="close-btn" (click)="clearError()">×</button>
            </div>
        </div>
    </div>

    <div class="applied-query-section" *ngIf="appliedQuery">
        <div class="applied-query-card">
            <div class="query-header">
                <strong>Applied Query:</strong>
                <div class="query-actions">
                    <button class="copy-btn" (click)="copyQuery()">Copy</button>
                    <button class="remove-btn" (click)="clearQuery()">Remove</button>
                </div>
            </div>
            <div class="query-text">{{ appliedQuery }}</div>
        </div>
    </div>


    <div class="action-buttons" *ngIf="appliedQuery">
        <button class="action-btn" (click)="clearQuery()">Clear Query</button>
    </div>
</div> -->
